import type { FC } from 'react';

import type { IconProps } from './type';

export const CashPacksIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height={15}
      viewBox="0 0 15 15"
      width={15}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.374.098h13.49c.093 0 .187.02.28.058.095.04.176.104.247.196.07.065.126.15.167.253a.9.9 0 0 1 .061.332v13.32a.9.9 0 0 1-.061.333.677.677 0 0 1-.167.254.603.603 0 0 1-.246.195.725.725 0 0 1-.281.059H1.374a.725.725 0 0 1-.28-.059.603.603 0 0 1-.247-.195.677.677 0 0 1-.166-.254.899.899 0 0 1-.062-.332V.938C.62.82.64.71.681.604A.678.678 0 0 1 .847.352a.797.797 0 0 1 .246-.186.638.638 0 0 1 .281-.068Zm4.128 9.16v1.68h1.862v1.66h1.51v-1.66h.738c.258 0 .5-.056.729-.167.228-.11.43-.263.606-.459.176-.195.31-.42.404-.673.094-.254.14-.518.14-.791 0-.274-.046-.537-.14-.791a2.067 2.067 0 0 0-.404-.674 1.957 1.957 0 0 0-.606-.46 1.65 1.65 0 0 0-.729-.165H6.626a.345.345 0 0 1-.15-.03.366.366 0 0 1-.113-.087.524.524 0 0 1-.088-.137.378.378 0 0 1-.035-.156c0-.052.011-.105.035-.157a.524.524 0 0 1 .088-.136.366.366 0 0 1 .114-.088c.04-.02.09-.03.15-.03h4.11v-1.68H8.873v-1.66h-1.51v1.66h-.738c-.257 0-.5.056-.729.167-.228.11-.43.263-.606.459-.175.195-.31.42-.404.674-.093.254-.14.517-.14.79 0 .274.047.538.14.792.094.254.229.478.404.673.176.196.378.349.606.46.229.11.472.165.73.165h2.985c.059 0 .108.01.15.03.04.02.078.049.114.088.035.039.064.084.087.136a.378.378 0 0 1 .036.157.378.378 0 0 1-.036.156.524.524 0 0 1-.087.137.366.366 0 0 1-.115.087.345.345 0 0 1-.149.03h-4.11Z"
        fill="#B4BAE9"
      />
    </svg>
  );
};
